var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunity = function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ADB5BD",
    d: "M16.5625,9.09090909 C17.9086941,9.09090909 19,10.1898465 19,11.5454545 C19,12.9010626 17.9086941,14 16.5625,14 C15.2163059,14 14.125,12.9010626 14.125,11.5454545 C14.125,10.1898465 15.2163059,9.09090909 16.5625,9.09090909 Z M9.25,5 C11.0449254,5 12.5,6.46524991 12.5,8.27272727 C12.5,10.0802046 11.0449254,11.5454545 9.25,11.5454545 C7.45507456,11.5454545 6,10.0802046 6,8.27272727 C6,6.46524991 7.45507456,5 9.25,5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212529",
    d: "M9.48611778,13 C13.4760137,13 16.7540697,15.0065438 16.998262,19.3 C17.0079899,19.4710398 16.998262,20 16.3722499,20 L2.60625186,20 L2.60625186,20 C2.39726013,20 1.98294854,19.5267825 2.00054307,19.2993048 C2.32354877,15.1232014 5.55159362,13 9.48611778,13 Z M16.6677814,14.7507052 L16.5733073,14.75 C19.4548988,14.75 21.8223837,16.2549078 21.9987447,19.475 C22.0057705,19.6032799 21.9987447,20 21.546625,20 L18.3333333,20 L18.3333333,20 C18.3333333,18.0305062 17.7136245,16.2129903 16.6677814,14.7507052 Z"
  }))));
};
export default SvgCommunity;